import type { MaybeRefOrGetter } from '@vueuse/core';
import { computed, toValue } from 'vue';
import { useI18n } from 'vue-i18n';

export const useInsuranceProviderOptions = (
  includeEmpty?: boolean,
  emptyLabel?: MaybeRefOrGetter<string | null | undefined>,
) => {
  const { t } = useI18n();

  return computed(() => [
    ...(includeEmpty
      ? [
          {
            label: toValue(emptyLabel) ?? t('insuranceProvider.all'),
            value: null,
          },
        ]
      : []),
    {
      label: t('insuranceProvider.axa'),
      value: 'axa',
    },
    {
      label: t('insuranceProvider.roland'),
      value: 'roland',
    },
    {
      label: t('insuranceProvider.europ'),
      value: 'europ',
    },
    {
      label: t('insuranceProvider.volvo'),
      value: 'volvo',
    },
    {
      label: t('insuranceProvider.jlr'),
      value: 'jlr',
    },
  ]);
};
